import {
  HTTP_INTERCEPTORS,
  HttpBackend,
  HttpClient,
  HttpInterceptor,
} from '@angular/common/http';
import { Inject, Injectable, InjectionToken } from '@angular/core';

import { InterceptingHandler } from '../../interceptors/intercepting-handler';

export const PODCAST_API_HTTP_INTERCEPTORS = new InjectionToken<
  HttpInterceptor[]
>('An abstraction on feature HttpInterceptor[]');

@Injectable({ providedIn: 'root' })
export class PodcastApiHttpClient extends HttpClient {
  constructor(
    backend: HttpBackend,
    @Inject(HTTP_INTERCEPTORS) interceptors: HttpInterceptor[],
    @Inject(PODCAST_API_HTTP_INTERCEPTORS)
    podcastApiHttpInterceptors: HttpInterceptor[],
  ) {
    super(
      new InterceptingHandler(
        backend,
        [interceptors, podcastApiHttpInterceptors].flat(),
      ),
    );
  }
}
